export const OrdersModeButtonKeys = {
  tickets: "TICKETS",
  collectables: "COLLECTABLES",
};
